
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlog/playlist",
      function () {
        return require("private-next-pages/vlog/playlist/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlog/playlist"])
      });
    }
  